import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-638bcc56"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "strategy-title-wrapper" }
const _hoisted_2 = { class: "title-row" }
const _hoisted_3 = { class: "strategy-title" }
const _hoisted_4 = { class: "strategy-tags" }




export default /*#__PURE__*/_defineComponent({
  __name: 'StrategyHeader',
  props: {
    strategyName: null,
    tags: null,
    isDark: { type: Boolean },
    strategyDetails: null
  },
  setup(__props: any) {

const props = __props as {
  strategyName: string
  tags: string[]
  isDark: boolean,
  strategyDetails: string
}



return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["card strategy-header-card", { 'is-dark': __props.isDark }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_a_tooltip, {
        title: `${__props.strategyDetails?.baseInfo?.name || ''} ${__props.strategyName}`,
        placement: "topLeft",
        overlayClassName: __props.isDark ? 'dark-tooltip' : ''
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.strategyName), 1)
          ])
        ]),
        _: 1
      }, 8, ["title", "overlayClassName"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['个股量化', '组合量化', '已订阅', '创建'], (tag) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (__props.tags.includes(tag))
            ? (_openBlock(), _createElementBlock("span", {
                class: "tag",
                key: tag
              }, _toDisplayString(tag), 1))
            : _createCommentVNode("", true)
        ], 64))
      }), 64))
    ])
  ], 2))
}
}

})